module.exports = __webpack_public_path__ + "static/media/logow.f2e6469c.png";